import { USAGE_CAPS_THRESHOLD_TYPES } from '../../components/customer/servicesAndUsage/usageCaps/usage.caps.constants';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
export var thresholdDisplayName = function thresholdDisplayName(threshold, thresholdType, currentBusinessUnitCurrency) {
  var $filter = getFilterService();
  var displayName = '';
  if (thresholdType.Code === USAGE_CAPS_THRESHOLD_TYPES.Currency) {
    displayName = currentBusinessUnitCurrency ? $filter('invCurrency')(threshold.MaximumAmount, currentBusinessUnitCurrency) : threshold.MaximumAmount;
  } else if (threshold !== undefined) {
    displayName = "".concat(threshold.MaximumAmount, " ").concat(thresholdType.Name);
  }
  return displayName;
};
export var mapThresholdOptions = function mapThresholdOptions(thresholds, thresholdType, currentBusinessUnitCurrency) {
  var allServices = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return thresholds.map(function (threshold) {
    return threshold.merge({
      DisplayName: thresholdDisplayName(threshold, thresholdType, currentBusinessUnitCurrency),
      selected: threshold.Default && allServices === false ? 'selected' : undefined
    });
  });
};
export var mapUsageCaps = function mapUsageCaps(usageCapsElections, currentBusinessUnitCurrency) {
  var allServices = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mappedUsageCaps = usageCapsElections.map(function (usageCap) {
    var mappedThresholds = mapThresholdOptions(usageCap.Thresholds, usageCap.ThresholdType, currentBusinessUnitCurrency, allServices);
    var findElectedThreshold = function findElectedThreshold(threshold) {
      return usageCap.ElectedThreshold && threshold.Id === usageCap.ElectedThreshold.Id;
    };
    return usageCap.merge({
      Thresholds: mappedThresholds,
      ElectedThreshold: allServices || !usageCap.Elected ? mappedThresholds[0] : mappedThresholds.find(findElectedThreshold)
    });
  });
  return mappedUsageCaps;
};